import React, { useEffect, useState } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";

// img
import shap1 from "../../../assets/images/shapes/01.png";
import shap2 from "../../../assets/images/shapes/02.png";
import shap3 from "../../../assets/images/shapes/03.png";
import shap4 from "../../../assets/images/shapes/04.png";
import shap5 from "../../../assets/images/shapes/05.png";
import shap6 from "../../../assets/images/shapes/06.png";
import { getAllUsers } from "../../../helpers/auth";
import {
  approveOpp,
  deleteOpp,
  getOpportunities,
} from "../../../helpers/opportunity";
import { RxCross1 } from "react-icons/rx";
import { SiNike } from "react-icons/si";
import { toast } from "react-hot-toast";

// const opplist = [
//   {
//     img: `${shap1}`,
//     name: "Anna Sthesia",
//     phone: "(760) 756 7568",
//     email: "annasthesia@gmail.com",
//     country: "USA",
//     status: "Active",
//     company: "Acme Corporation",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
// {
//     img: `${shap2}`,
//     name: "Brock Lee",
//     phone: "+62 5689 458 658",
//     email: "brocklee@gmail.com",
//     country: "Indonesia",
//     status: "Active",
//     company: "Soylent Corp",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
//   {
//     img: `${shap3}`,
//     name: "Dan Druff",
//     phone: "+55 6523 456 856",
//     email: "dandruff@gmail.com",
//     country: "Brazil",
//     status: "Pending",
//     company: "Acme Corporation",
//     joindate: "2019/12/01",
//     color: "bg-warning",
//   },
//   {
//     img: `${shap4}`,
//     name: "Hans Olo",
//     phone: "+91 2586 253 125",
//     email: "hansolo@gmail.com",
//     country: "India",
//     status: "Inactive",
//     company: "Vehement Capital",
//     joindate: "2019/12/01",
//     color: "bg-danger",
//   },
//   {
//     img: `${shap5}`,
//     name: "Lynn Guini",
//     phone: "+27 2563 456 589",
//     email: "lynnguini@gmail.com",
//     country: "Africa",
//     status: "Active",
//     company: "Massive Dynamic",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
//   {
//     img: `${shap6}`,
//     name: "Eric Shun",
//     phone: "+55 25685 256 589",
//     email: "ericshun@gmail.com",
//     country: "Brazil",
//     status: "Pending",
//     company: "Globex Corporation",
//     joindate: "2019/12/01",
//     color: "bg-warning",
//   },
//   {
//     img: `${shap3}`,
//     name: "aaronottix",
//     phone: "(760) 756 7568",
//     email: "budwiser@ymail.com",
//     country: "USA",
//     status: "Hold",
//     company: "Acme Corporation",
//     joindate: "2019/12/01",
//     color: "bg-info",
//   },
//   {
//     img: `${shap5}`,
//     name: "Marge Arita",
//     phone: "+27 5625 456 589",
//     email: "margearita@gmail.com",
//     country: "Africa",
//     status: "Complite",
//     company: "Vehement Capital",
//     joindate: "2019/12/01",
//     color: "bg-success",
//   },
//   {
//     img: `${shap2}`,
//     name: "Bill Dabear",
//     phone: "+55 2563 456 589",
//     email: "billdabear@gmail.com",
//     country: "Brazil",
//     status: "Active",
//     company: "Massive Dynamic",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
// ];

export const showLimitedText = (text, limit) => {
  text = String(text);
  if (text.length > limit) {
    return text.substring(0, limit) + "...";
  }
  return text;
};

const OpportunityList = () => {
  const [opplist, setOpplist] = useState([]);
  const [approved, setApproved] = useState(true);
  const [error, setError] = useState(false);

  const ApiCall = async (approved) => {
    console.log(approved, "approved");
    let res = await getOpportunities(1, approved, 10);

    if (res.data.success) {
      setOpplist(res.data.data.opportunities);
    } else {
      setOpplist([]);
      setError("Something went wrong");
    }
  };

  const handleDelete = async (id) => {
    let res = await deleteOpp(id);

    if (res.data.success) {
      ApiCall(approved);
    }
  };

  const handleApprove = async (id, val) => {
    let res = await approveOpp(id, val);
    // console.log(res, "res");
    if (res.data.success) {
      ApiCall(approved);
      toast.success("Action done Successfully");
    }
  };

  useEffect(() => {
    ApiCall(approved);
  }, [approved]);

  console.log(approved, "approved outside");
  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Opportunity List</h4>
                </div>
                <div>
                  <select
                    name="approved"
                    id=""
                    style={{ padding: "10px" }}
                    onChange={(e) => {
                      setApproved(e.target.value);
                    }}
                  >
                    {/* <option value="all">All</option> */}
                    <option value={true} style={{ padding: "10px" }}>
                      Approved
                    </option>
                    <option value={false} style={{ padding: "10px" }}>
                      Pending
                    </option>
                  </select>
                </div>
              </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        {/* <th>Profile</th> */}
                        <th>Company Name</th>
                        <th>Email</th>
                        <th>Job Title</th>
                        {/* <th>Role</th> */}
                        {/* <th>Country</th> */}
                        {/* <th>Status</th> */}
                        {/* <th>Company</th> */}
                        <th>Status</th>
                        <th>Name of Contact Person</th>
                        <th>Total Applicants</th>
                        <th min-width="100px">Action</th>
                        <th min-width="100px">Change Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {error && <p className="text-danger">{error}</p>}
                      {opplist.length === 0 && (
                        <p className="text-danger">No data found</p>
                      )}
                      {opplist.map((item, idx) => (
                        <tr key={idx}>
                          {/* <td className="text-center">
                            <Image
                              className="bg-soft-primary rounded img-fluid avatar-40 me-3"
                              src="https://source.unsplash.com/user/c_v_r/100x100"
                              alt="profile"
                            />
                          </td> */}
                          <Link to={`/dashboard/app/opportunity/${item._id}`}>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "15px",
                              }}
                            >
                              {showLimitedText(item.companyName, 15)}
                            </td>
                          </Link>
                          {/* <td>{item.phone}</td> */}
                          <td>
                            <a href={`mailto:${item.email}`}>
                              {showLimitedText(item.email, 15)}
                            </a>
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {showLimitedText(item.jobTitle, 15)}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {item.approved ? (
                              <span
                                className="badge bg-success"
                                onClick={() => {
                                  handleApprove(item._id, false);
                                }}
                              >
                                Approved
                              </span>
                            ) : (
                              <span
                                style={{ cursor: "pointer" }}
                                className="badge bg-warning"
                                onClick={() => {
                                  handleApprove(item._id, true);
                                }}
                              >
                                Pending
                              </span>
                            )}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {showLimitedText(item.name, 15)}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {item.applicants}
                          </td>
                          <td>
                            <div className="flex align-items-center list-user-action">
                              <div
                                onClick={() => {
                                  handleDelete(item._id);
                                }}
                                className="btn btn-sm btn-icon btn-danger"
                                data-toggle="tooltip"
                                data-placement="top"
                                title=""
                                data-original-title="Delete"
                                to="#"
                              >
                                <span className="btn-inner">
                                  <svg
                                    width="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M20.708 6.23975H3.75"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </span>
                              </div>{" "}
                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              padding: "15px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <RxCross1
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => handleApprove(item._id, false)}
                              />
                              <SiNike
                                style={{
                                  color: "green",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleApprove(item._id, true)}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default OpportunityList;
